import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { properties } from '../../../../environments/properties';
import { AuthService } from "../../../shared/services/auth.service";
import { SubscriptionService } from "../../../shared/services/subscription.service";
import { _windowUtil } from '../../../shared/utils/ui-utils';
import { ParamService } from 'src/app/shared/services/param.service';

declare const AB: any;
@Component({
  selector: 'manage-subscription-summary',
  templateUrl: './manage-subscription.component.html',
  styleUrls: ['./manage-subscription.component.scss'],
  providers: [SubscriptionService]
})
export class ManageSubscriptionComponent implements OnInit {

  public userSubscriptionDetails: any;
  freshpassSubscriptionType: string;
  userInfo: any;
  tenderInfo: any;
  showTenders = false;
  showTermsSection = true;
  lifeSavings: number;
  currentEnvironment;
  isFPTenderAvailable = false;
  isTrialPlan = false
  displaySubTypeLink = false;

  properties = properties;

  enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
  programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;
    
  pageName = this.programDisplayData?.freshpassData?.manageText;

  snapFlagEnabled: boolean = this.properties.featureFlags.enableSnap;

  MONTHLY_PLAN_NAME: string = this.programDisplayData?.manage?.MONTHLY;
  ANNUAL_PLAN_NAME: string = this.programDisplayData?.manage?.ANNUAL;
  suspendedGovElibilityText: string = this.programDisplayData?.freshpassData?.suspendedGovElibilityText;
  govAssistanceElibilityText: string = this.programDisplayData?.freshpassData?.govAssistanceElibilityText;
  snapVerificationURL_UCA: string = this.programDisplayData?.urlPath?.snapVerificationURL_UCA;

  freshpassManageTitle = "";
  banner: string = "";
  capitalizedBanner: string = "";


  public windowUtil = _windowUtil(window);

  constructor(public subscriptionService: SubscriptionService,
    public authService: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private paramService: ParamService
  ) {
    this.banner = this.paramService.banner;
    this.capitalizedBanner = this.paramService.capitalizedBanner;
    this.freshpassManageTitle = this.programDisplayData?.freshpassData?.freshpassManageTitle?.replace("{banner}", this.capitalizedBanner);
    this.setTitle(`${this.programDisplayData.title} - Manage Subscription`);
  }

  ngOnInit() {

    this.setProps();
    this.activeRoute.data.subscribe({
      next: (data) => {
        let isSessionValid = this.authService.isTokenValidForSession(data?.tokenObject);
        if (isSessionValid) {
          const sessionData = { ...(data?.tokenObject), authToken: data?.tokenObject?.['SWY_SHOP_TOKEN'] };
          if (sessionData) {
            this.userInfo = sessionData;
            this.initSubscribes();
            this.checkNotifyMessage();
          }
        } else {
          this.authService.redirectToSSO(data?.tokenObject);
        }
      },
      error: (err) => {
        this.authService.redirectToSSO({});
      }
    });
  }

  setProps(): void {
    this.currentEnvironment = this.subscriptionService.getEnvironment();
  }

  setTitle(newTitle: string): void {
    this.titleService.setTitle(newTitle);
  }

  initSubscribes() {
    this.subscriptionService.getUserSubscriptionDetails(this.userInfo, this.currentEnvironment).subscribe((data) => {
      if (data?.Data) {
        this.redirectIfNotPrimaryUser(data?.Data);
        this.setUserSubscriptionDetails(data?.Data);
      }
    }, error => {
      if (error) {
        if (error?.error && error?.error?.errorCode) {
          this.handleErrorCode(error.error.errorCode)
        }
      } else {
        this.redirectToSubscribe();
      }
    })
  }

  setUserSubscriptionDetails(userSubDetails) {
    this.userSubscriptionDetails = userSubDetails;
    this.lifeSavings = this.userSubscriptionDetails?.lifeSavings || 0;
    this.isTrialPlan = this.subscriptionService.getTrialPlanStatus(this.userSubscriptionDetails);
    if (this.userSubscriptionDetails?.isPrimaryFreshPassUser === false) {
      this.router.navigate([this.programDisplayData?.urlPath?.CONFIRMATION_PATH]);
    }
    if (this.userSubscriptionDetails?.subscriptionStatus && this.userSubscriptionDetails?.subscriptionStatus !== 'CANCELLED') {
      this.displayCurrentPaymentComponent()
      this.sendMessageCenterData();
      this.updateAnalyticsSubscriptionInfo();
    } else {
      this.redirectToSubscribe();
    }
  }

  displayCurrentPaymentComponent() {
    if (this.userSubscriptionDetails?.subscriptionStatus !== this.programDisplayData?.manage?.PENDING_CANCELLATION) {
      this.setActiveUserTendersDetails();
    } else {
      this.showTermsSection = false;
    }
  }

  setActiveUserTendersDetails() {
    if (this.userInfo && this.currentEnvironment) {
      this.subscriptionService.getTenders(this.userInfo, this.currentEnvironment).subscribe((tenderData) => {
        this.showTenders = true;
        if (tenderData?.paymentMethods && tenderData?.paymentMethods?.length > 0) {
          tenderData?.paymentMethods?.forEach((tenderObj) => {
            if (tenderObj?.primaryPurposes?.includes(this.programDisplayData?.manage?.DELIVERY_SUBSCRIPTION)) {
              this.isFPTenderAvailable = true;
              this.tenderInfo = tenderObj;
              let normalizedMaskedLength = this.tenderInfo?.maskedNumber?.length;
              if (normalizedMaskedLength && normalizedMaskedLength > 4) {
                let temp = this.tenderInfo?.maskedNumber?.slice(normalizedMaskedLength - 5, normalizedMaskedLength - 1);
                this.tenderInfo.maskedNumber = temp;
              }
            } else {
              this.isFPTenderAvailable = false;
            }
          });
        }
      });
    }
  }

  sendMessageCenterData() {
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.ACTIVE) {
      this.sendActiveStatusMessage();
    }
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.TRIAL) {
      this.sendTrialMessageCenterData();
    }
    if ((this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PENDING_ACTIVATION) && (this.userSubscriptionDetails?.status !== this.programDisplayData?.manage?.SUSPENDED) &&
      (this.userSubscriptionDetails?.pendingRenewalDate && this.userSubscriptionDetails?.pendingFee && this.userSubscriptionDetails?.pendingSubsCode)) {
      if (this.userSubscriptionDetails?.pendingDiscountType?.toLowerCase() === this.programDisplayData?.prechurn?.retentionDiscountType) {
        this.sendPreChurnDiscountSuccessStatusMessage();
      } else {
        this.sendPendingActivationStatusMessage();
      }
    }
    if ((this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PROCESSING) &&
      (this.userSubscriptionDetails?.renewalDate && this.userSubscriptionDetails?.fee && this.userSubscriptionDetails?.subscriptionCode)) {
      this.sendProcessingStatusMessage()
    }
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PENDING_CANCELLATION) {
      this.showTenders = false;
      this.sendPendingCancellationStatusMessage();
    }
    if (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.SUSPENDED?.toUpperCase() ||
      (this.userSubscriptionDetails?.subscriptionStatus === this.programDisplayData?.manage?.PENDING_ACTIVATION && this.userSubscriptionDetails?.status === this.programDisplayData?.manage?.SUSPENDED)) {
      this.sendSuspendedStatusMessage();
    }
    //If user is snap verified and PromoInfo is coming. it will take presedence over other messages
    if (this.userSubscriptionDetails?.isSheerVerified && this.userSubscriptionDetails?.promoInfo) {
      this.sendSnapVerifiedMessage();
    }
  }

  sendActiveStatusMessage() {
    this.sendSnapVerifiedMessage();
  }

  sendSnapVerifiedMessage() {
    if (this.snapFlagEnabled) {
      if (this.userSubscriptionDetails?.isSheerVerified && this.userSubscriptionDetails?.promoInfo) {
        this.subscriptionService.messageCenterData$.next(
          {
            value: this.userSubscriptionDetails?.promoInfo,
            isErrorMsg: false,
            isVerifiedPromoMessage: true
          });
      }
    }
  }

  sendPreChurnDiscountSuccessStatusMessage() {
    let pendingPricingDetail = this.subscriptionService.getPricingDetail(this.userSubscriptionDetails?.pendingPricingDetail, this.userSubscriptionDetails?.pendingSubscriptionType);
    this.subscriptionService.messageCenterData$.next(
      {
        value: this.programDisplayData?.prechurn?.successStatusMessage?.replace('{pendingFee}', this.userSubscriptionDetails?.pendingFee).replace('{pendingPricingDetail}', pendingPricingDetail),
        isErrorMsg: false,
        isVerifiedPromoMessage: true
      });
  }

  sendTrialMessageCenterData() {
    let expirationPlanType = this.getExpirationPlanType();
    let pricingDetail = this.subscriptionService.getPricingDetail(this.userSubscriptionDetails?.pricingDetail, this.userSubscriptionDetails?.subscriptionType);

    this.subscriptionService.messageCenterData$.next(
      {
        value: this.programDisplayData?.manage?.TRIAL_STATUS_MESSAGE
          .replace('{fee}', this.userSubscriptionDetails?.fee)
          .replace('{pricingDetail}', pricingDetail)
          .replace('{expirationDate}', this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate))
          .replace('{expirationPlanType}', expirationPlanType)
          .replace('{renewalDate}', this.subscriptionService.convertDate(this.userSubscriptionDetails?.renewalDate)),
        isErrorMsg: false,
      }
    );
  }

  sendPendingActivationStatusMessage() {
    let planType = this.getPlanType(this.userSubscriptionDetails?.pendingSubsCode)
    if (this.isTrialPlan) {
      this.subscriptionService.messageCenterData$.next(
        {
          value: this.programDisplayData?.manage?.YOUR_FREE_TRIAL_ENDS_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate) + ', ' + this.programDisplayData?.manage?.YOU_LL_BE_AUTOMATICALLY_ENROLLED_INTO_THE + '<b>' + planType + '</b> ' + this.programDisplayData?.manage?.FRESH_PASS_PLAN_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails?.pendingRenewalDate) + '.',
          isErrorMsg: false,
        });
    } else {
      if (this.snapFlagEnabled) {
        //message center message for SNAP
        let pendingFee = this.removeTrailingZeroesInFee(this.userSubscriptionDetails?.pendingFee);
        let pendingPricingDetail = this.subscriptionService.getPricingDetail(this.userSubscriptionDetails?.pendingPricingDetail, this.userSubscriptionDetails?.pendingSubscriptionType);

        let pendingActivationStatusMessage = this.programDisplayData?.freshpassData?.pendingActivationStatusMessage?.replace('{pendingFee}', pendingFee).replace('{pendingPricingDetail}', pendingPricingDetail);
        this.subscriptionService.messageCenterData$.next(
          {
            value: pendingActivationStatusMessage,
            isErrorMsg: false,
          });
      } else {
        this.subscriptionService.messageCenterData$.next(
          {
            value: this.programDisplayData?.manage?.YOUR + this.userSubscriptionDetails?.pendingFee + ' <b>' + planType + '</b> ' + this.programDisplayData?.manage?.FRESH_PASS_PLAN_WILL_BECOME_EFFECTIVE_AFTER_THE_CURRENT_PLAN_EXPIRES_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate),
            isErrorMsg: false,
          });
      }
    }
  }

  sendProcessingStatusMessage() {
    let planType = this.getPlanType(this.userSubscriptionDetails?.subscriptionCode);
    if (this.isTrialPlan) {
      this.subscriptionService.messageCenterData$.next(
        {
          value: this.programDisplayData?.manage?.YOUR_FREE_TRIAL_ENDS_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate) + ', ' + this.programDisplayData?.manage?.YOU_LL_BE_AUTOMATICALLY_ENROLLED_INTO_THE + ' <b>' + planType + '</b> ' + this.programDisplayData?.manage?.FRESH_PASS_PLAN_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails?.renewalDate) + '.',
          isErrorMsg: false,
        });
    } else {
      if (this.snapFlagEnabled) {
        //message center message for SNAP
        let pendingFee = this.removeTrailingZeroesInFee(this.userSubscriptionDetails?.pendingFee);
        let pendingPricingDetail = this.subscriptionService.getPricingDetail(this.userSubscriptionDetails?.pendingPricingDetail, this.userSubscriptionDetails?.pendingSubscriptionType);


        let pendingActivationStatusMessage = this.programDisplayData?.freshpassData?.pendingActivationStatusMessage?.replace('{pendingFee}', pendingFee).replace('{pendingPricingDetail}', pendingPricingDetail);
        this.subscriptionService.messageCenterData$.next(
          {
            value: pendingActivationStatusMessage,
            isErrorMsg: false,
          });
      } else {
        this.subscriptionService.messageCenterData$.next(
          {
            value: this.programDisplayData?.manage?.YOUR + this.userSubscriptionDetails?.fee + ' <b>' + planType + '</b>' + this.programDisplayData?.manage?.FRESH_PASS_PLAN_WILL_BECOME_EFFECTIVE_AFTER_THE_CURRENT_PLAN_EXPIRES_ON + this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate),
            isErrorMsg: false,
          });
      }
    }
  }

  sendPendingCancellationStatusMessage() {
    if (this.isTrialPlan) {
      let message = this.programDisplayData?.manage?.YOUR_CURRENT_FRESH_PASS_PLAN_HAS_BEEN + ' ' + this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate) + ', ' + this.programDisplayData?.manage?.YOU_CAN_STILL_CONTINUE_TO_USE_FRESH_PASS_UNTIL + this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate) + '.';
      message = message.replace(/(\{banner\})/g, this.capitalizedBanner);
      console.log('message', message);
      this.subscriptionService.messageCenterData$.next(
        {
          value: message,
          isErrorMsg: false,
        });
    } else {
      let message = this.programDisplayData?.manage?.YOUR_CURRENT_FRESH_PASS_PLAN + ' ' + this.subscriptionService.convertDate(this.userSubscriptionDetails?.curentPlanExpiryDate) + '.';
      message = message.replace(/(\{banner\})/g, this.capitalizedBanner);
      console.log('message', message);
      this.subscriptionService.messageCenterData$.next(
        {
          value: message,
          isErrorMsg: false,
        });
    }
  }

  sendSuspendedStatusMessage() {
    if (this.snapFlagEnabled && this.userSubscriptionDetails?.isPromoExpired && this.userSubscriptionDetails?.promoInfo.includes(this.govAssistanceElibilityText)) {
      const reverifySnapMessage = this.suspendedGovElibilityText + `<a href="${this.snapVerificationURL_UCA}" role="button" class='verificationLink' tabindex="0">` + this.govAssistanceElibilityText + `</a>`;
      this.subscriptionService.messageCenterData$.next(
        {
          value: reverifySnapMessage,
          isErrorMsg: true,
        });
    } else {
      this.subscriptionService.messageCenterData$.next(
        {
          value: this.programDisplayData?.manage?.YOUR_FRESH_PASS_PLAN_IS.replace('{banner}', this.capitalizedBanner),
          isErrorMsg: true,
        });
    }
  }

  checkNotifyMessage(): void {
    let text = localStorage.getItem(this.programDisplayData?.manage?.NOTIFY_MESSAGE);

    let messageJson = JSON.parse(text);

    if (messageJson && !messageJson.isDisplayed) {
      if (messageJson.message && messageJson.message.length > 0) {
        AB.COMMON.userNotify(messageJson.message);
      }
      messageJson.isDisplayed = true;
      text = JSON.stringify(messageJson);
      localStorage.setItem(this.programDisplayData?.manage?.NOTIFY_MESSAGE, text);
    }
  }

  getExpirationPlanType() {
    let expirationPlanType = '';
    if (this.userSubscriptionDetails?.subscriptionType?.toLowerCase()?.indexOf(this.programDisplayData?.manage?.MONTHLY?.toLowerCase()) >= 0) {
      expirationPlanType = this.MONTHLY_PLAN_NAME;
    } else {
      expirationPlanType = this.ANNUAL_PLAN_NAME
    }
    return expirationPlanType;
  }

  getPlanType(subsCode) {
    if (subsCode === this.programDisplayData?.manage?.F9_B88_F7_E_5_F54_4536_AFC0_8_B080_D189_CDF) {
      return this.MONTHLY_PLAN_NAME
    } else {
      return this.ANNUAL_PLAN_NAME
    }
  }

  updateAnalyticsSubscriptionInfo() {
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo('manage', {});
    }
  }

  handleErrorCode(errorCode) {
    this.redirectToSubscribe();
  }

  shopAfterCancellation() {
    this.windowUtil.setWindowLocationHref('/shop/home.html');
  };

  removeTrailingZeroesInFee(fee: string): string {
    if (typeof fee !== 'string') {
      return fee;
    }
    if (fee.endsWith('.00')) {
      return fee.slice(0, -3);
    }
    return fee;
  }

  redirectToSubscribe() {
    const queryParams = this.activeRoute.snapshot.queryParams;
    this.router.navigate([this.programDisplayData?.urlPath.SUBSCRIBE_PATH], { queryParams });
  }

  redirectIfNotPrimaryUser(userSubscriptionDetails) {
    if (userSubscriptionDetails?.isPrimaryFreshPassUser === false) {
      this.router.navigate([this.programDisplayData?.urlPath?.CONFIRMATION_PATH]);
    }
  }
}
